import { LoginRequest, SystemUser, SystemUserCharacter } from '../../../domain/user.model';

export namespace UserAction {
    export class Login {
        static readonly type = 'UserAction.Login';

        constructor(public request: LoginRequest, public url: string = null) {
        }
    }

    export class Logout {
        static readonly type = 'UserAction.Logout';
    }

    export class Unauthorized {
        static readonly type = 'UserAction.Unauthorized';
    }

    export class ClearCurrentUser {
        static readonly type = 'UserAction.ClearCurrentUser';
    }

    export class LoginFailed {
        static readonly type = 'UserAction.LoginFailed';
    }

    export class SetCurrentUser {
        static readonly type = 'UserAction.SetCurrentUser';

        constructor(public user: SystemUser) {
        }
    }

    export class UpdateUser {
        static readonly type = 'UserAction.UpdateUser';

        constructor(public user: SystemUser) {
        }
    }

    export class ChangeCharacter {
        static readonly type = 'UserAction.ChangeCharacter';

        constructor(public entity: SystemUserCharacter) {
        }
    }

    export class SetURL {
        static readonly type = 'UserAction.SetURL';

        constructor(public url: string) {
        }
    }

    export class ForgotPassword {
        static readonly type = 'UserAction.ForgotPassword';

        constructor(public username: string) {
        }
    }

    export class ResetPassword {
        static readonly type = 'UserAction.ResetPassword';

        constructor(public token: string, public password: string, public password2: string) {
        }
    }
}
